import { render, staticRenderFns } from "./MemoDetailsPage.vue?vue&type=template&id=607fb7fe&scoped=true"
import script from "./MemoDetailsPage.vue?vue&type=script&lang=js"
export * from "./MemoDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./MemoDetailsPage.vue?vue&type=style&index=0&id=607fb7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fb7fe",
  null
  
)

export default component.exports